<div class="container">
  <div class="row mb-2">
    <div class="col-sm-12">
      <ng-container>
        <div class="row">
          <div class="col-sm-12">
            <tan-loader [loading]="(projectListLoading$ | async)" [loadingText]="'<p>Fetching projects</p>'">
            </tan-loader>

            <div class="kwikspace-section" *ngIf="!(projectListLoading$ | async) && !projectSelected">
              <ng-container *ngIf="projects.length > 0 && !designSelected">
                <h4 class="mb-3">Choose project:</h4>
                <table class="table table-striped kwikspace-table">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let project of projects; let i = index">
                      <td>{{ project.name }}</td>
                      <td>
                        <button type="button" class="btn btn-primary mr-2"
                          (click)="viewSelectedProject(project)">View</button>
                        <button type="button" class="btn btn-secondary"
                          (click)="setSelectedProject(project)">Select</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <div class="row justify-content-center" *ngIf="projects.length == 0">
                <div class="col-sm-12 d-flex justify-content-center">
                  <tan-alert-message [errorType]="'info'" [message]="'No projects found'"></tan-alert-message>
                </div>
              </div>
            </div>

            <div class="row justify-content-center"
              *ngIf="!(projectListLoading$ | async) && (projectListError$ | async)">
              <div class="col-sm-12 d-flex justify-content-center">
                <tan-alert-message [errorType]="'error'" [message]="'Could not retrieve Projects from Floor Planner'">
                </tan-alert-message>
              </div>
            </div>

            <tan-loader [loading]="(projectLoading$ | async)" [loadingText]="'<p>Fetching project Designs</p>'">
            </tan-loader>

            <div class="kwikspace-section" *ngIf="!(projectLoading$ | async) && projectSelected">
              <ng-container *ngIf="designs.length > 0">
                <h4 class="mb-3">Choose your design:</h4>
                <table class="table table-striped kwikspace-table">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let design of designs; let i = index">
                      <td>{{ design.name }}</td>
                      <td>
                        <button type="button" class="btn btn-primary mr-2"
                          (click)="viewSelectedDesign(design)">View</button>
                        <button type="button" class="btn btn-secondary"
                          (click)="setSelectedDesign(design)">Select</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <div class="row justify-content-center" *ngIf="designs.length == 0">
                <div class="col-sm-12 d-flex justify-content-center">
                  <tan-alert-message [errorType]="'info'" [message]="'No Designs for this Project found'">
                  </tan-alert-message>
                </div>
              </div>
            </div>

            <div class="row justify-content-center" *ngIf="(projectError$ | async) && !(projectLoading$ | async)">
              <div class="col-sm-12 d-flex justify-content-center">
                <tan-alert-message [errorType]="'error'"
                  [message]="'Could not retrieve Designs from selected Floor Planner Project'">
                </tan-alert-message>
              </div>
            </div>

          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<tan-modal #floorplannerViewDesignModal [size]="'lg'" [title]="'Design Visualisation'" [showInformationBlock]="false"
  [showActionButton]="false">
  <div modal-content>
    <div class="container">
      <div class="row">
        <div class="col-sm-12 d-flex justify-content-center">
          <img [src]="selectedDesignThumbnail" *ngIf="selectedDesignThumbnail != null">
          <p *ngIf="selectedDesignThumbnail == null">No Visualisation Available</p>
        </div>
      </div>
    </div>
  </div>
</tan-modal>

<tan-modal #floorplannerViewProjectModal [size]="'xl'" [title]="'Project Visualisation'" [showInformationBlock]="false"
  [showActionButton]="false">
  <div modal-content>
    <div class="container">
      <div class="row">
        <div class="col-sm-12" *ngIf="selectedProjectThumbnail != null">
          <div class="row">
            <div class="col-sm-12">
              <h4 class="mb-3">2D</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 d-flex justify-content-center">
              <img [src]="selectedProjectThumbnail">
            </div>
          </div>
        </div>
        <div class="col-sm-12" *ngIf="selectedProjectThumbnail3d != null">
          <div class="row">
            <div class="col-sm-12">
              <h4 class="mb-3">3D</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 d-flex justify-content-center">
              <img [src]="selectedProjectThumbnail3d">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</tan-modal>